module.exports = __webpack_public_path__ + "img/Group4.e8cbe2ed.png";